<template>
  <div id="page-homeletter" class="d-flex">
    <MainBarMenu />
       <!-- <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div> -->
    <div class="layout-content container-fluid ">
      <HeadingUser />   
      <div class="page-letter py-3">
        <div class="container">
          <p class="title-3 mb-0">EDICIÓN DE PLANTILLA: PERMISOS SINDICALES</p>
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6 col-xl-6">
              <div class="cont-letter-text d-flex flex-column justify-content-around mt-0 mt-md-1">
              <!-- .cont-title> -->
              <form 
                @submit="sendLetterChgs"
                onsubmit="return false"
                class="form-letter mt-5 mb-5 mb-md-5 align-items-center"
                >
                
                <div class="row">
                  <div class="col-12 mb-md-2">                    
                    <p class="title-1">1. Hoja Membreteada</p>
                  </div>  
                </div>   
                <div class="row">
                  <div class="col-1 ml-3 mb-md-0">
                    <img style="width:45px;height:80px;" src="@/assets/images/icons/header.svg">
                  </div>  
                  <div class="col-4 ml-0 mb-md-0">
                    <p class="title-1">Encabezado</p>                    
                      <label class="custom-file-upload">
                        <input type="file" id="header" name="header" @change="headerSelected"/>
                        <img style="width:25px;height:30px;" src="@/assets/images/icons/upheader.svg">
                        <p class="p3">Cargar encabezado</p>
                        <span v-if="!header_img">
                          <p class="p3"></p>
                        </span>
                        <span v-else>
                          <p class="p3"><b>{{ header_img }}</b></p>
                        </span>
                      </label>
                  </div>  
                  <div class="col-1 ml-0 mb-md-0">
                    <img style="width:45px;height:80px;" src="@/assets/images/icons/footer.svg">                    
                  </div>
                  <div class="col-5 ml-0 mb-md-0">
                    <p class="title-1">Pie de página</p>                    
                    <label class="custom-file-upload">
                      <input type="file" id="footer" name="footer" @change="footerSelected"/>
                      <img style="width:25px;height:30px;" src="@/assets/images/icons/upheader.svg">
                      <p class="p3">Cargar pie de página</p>
                      <span v-if="!footer_img">
                        <p class="p3"></p>
                      </span>
                      <span v-else>
                        <p class="p3"><b>{{ footer_img }}</b></p>
                      </span>
                    </label>
                  </div>
                </div>                            
                <div class="row pt-3">
                  <div class="col-12 mb-md-0">                    
                    <p class="title-1">2. Contexto Legal</p>
                  </div>                            
                </div>
                <div class="row">
                  <div class="col-11 ml-3 mb-md-0">                    
                    <textarea class="form-control" 
                    v-model="legalContext" 
                    placeholder="Redacta el contexto legal..." 
                    rows="4" cols="35"
                    value="sass">
                      
                    </textarea>
                  </div>                            
                </div>
                <div class="row">
                  <div class="col-11 ml-3 mb-md-2">                    
                    <!--p class="p2">Guardar texto</p-->
                  </div>
                </div>
                <div  class="row pt-3">
                  <div class="col-12 mb-md-0">                    
                    <p class="title-1">3. Firmas</p>
                  </div>                            
                </div>
                <div class="row">
                  <div class="col-5 ml-3 mb-md-2">
                    <b-card-group>
                      <b-card>
                        <b-card-text>
                          <span v-if="!signature1">
                            <p class="p3">Sin archivo</p>
                          </span>
                          <span v-else>
                            <p class="p3"><b>{{ signature1 }}</b></p>
                          </span>
                        </b-card-text>                        
                      </b-card>
                    </b-card-group>
                  </div>
                  <div class="col-5 ml-3 mb-md-2">
                    <b-card-group>
                      <b-card>
                        <b-card-text>
                          <span v-if="!signature2">
                            <p class="p3">Sin archivo</p>
                          </span>
                          <span v-else>
                            <p class="p3"><b>{{ signature2 }}</b></p>
                          </span>
                        </b-card-text>                        
                      </b-card>
                    </b-card-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-5 ml-3 mb-md-2">                    
                    <p class="p2">
                      <label class="custom-file-upload">
                          <input type="file" id="signature1" name="signature1" @change="signature1Selected"/>                          
                          Cargar firma
                      </label>
                    </p>                        
                  </div>
                  <div class="col-5 ml-3 mb-md-2">
                    <p class="p2">
                      <label class="custom-file-upload">
                          <input type="file" id="signature2" name="signature2" @change="signature2Selected"/>                          
                          Cargar firma
                      </label>
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-5 ml-3 mb-md-0">
                    <p class="p3">Nombre:</p>
                  </div>
                  <div class="col-5 ml-3 mb-md-0">
                    <p class="p3">Nombre:</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-5 ml-3 mb-md-2">
                    <input type="text" 
                      v-model="name1"                       
                      class="form-control" id="name1">
                  </div>
                  <div class="col-5 ml-3 mb-md-2">
                    <input type="text" 
                      v-model="name2" 
                      class="form-control" id="name2">
                  </div>
                </div>
                <div class="row">
                  <div class="col-5 ml-3 mb-md-0">
                    <p class="p3">Cargo sindical:</p>
                  </div>
                  <div class="col-5 ml-3 mb-md-0">
                    <p class="p3">Cargo sindical:</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-5 ml-3 mb-md-2">
                    <input type="text" 
                      v-model="position1" 
                      class="form-control" id="position1">
                  </div>
                  <div class="col-5 ml-3 mb-md-3">
                    <input type="text" 
                      v-model="position2" 
                      class="form-control" id="position2">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mt-4" align="center" v-if="!loading">
                    <button 
                    type="submit"
                    class="btn btn-darkblue-1"
                    >
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.22222 20H17.7778C18.3671 20 18.9324 19.7659 19.3491 19.3491C19.7659 18.9324 20 18.3671 20 17.7778V5.55556L14.4444 0H2.22222C1.63285 0 1.06762 0.234126 0.650874 0.650874C0.234126 1.06762 0 1.63285 0 2.22222V17.7778C0 18.3671 0.234126 18.9324 0.650874 19.3491C1.06762 19.7659 1.63285 20 2.22222 20ZM4.44444 2.22222H8.88889V4.44444H11.1111V2.22222H13.3333V6.66667H4.44444V2.22222ZM4.44444 11.1111H15.5556V17.7778H4.44444V11.1111Z" fill="white"/>
                      </svg>
                      Guardar
                    </button>
                  </div>
                  <div class="col-12 mt-4" align="center" v-else-if="loading">
                    <div  class="spinner-border" role="status" align="center">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <small v-show="error.flag" class="alert-danger">{{ error.message }}</small>
                  <small v-show="success.flag" class="alert-heading">
                    <b-alert show variant="success">
                      <strong>{{ success.message }}</strong>
                    </b-alert>
                  </small>             
                </div>
              </form>  
              </div>
              <div>
                <b-modal 
                  ref="my-modal" 
                  hide-footer
                  centered
                  title="Atención al mensaje:"
                  no-close-on-backdrop
                  @hidden="hideModal">
                  <div class="d-block text-center">
                    <h3>{{this.msjModal}}</h3>
                  </div>
                  <b-button class="mt-3" variant="outline-danger"
                    block 
                    @click="hideModal">
                      Cerrar
                  </b-button>
                </b-modal>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6 col-xl-6">
              <TemplateLetter
                :key="keyComponent"
              />
            </div>
          <!-- .col -->
          </div>
        <!-- .row -->
        </div>
      <!-- .layout-content -->
      </div>
    </div>
  </div>
  <!-- #page-request -->
</template>

<script>
import TemplateLetter from "./TemplateLetter.vue";
import MainBarMenu from "@/components/layouts/MainBarMenu.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import { mapActions, mapState } from "vuex";
import serverConfig from "./../../services/config";

export default {
  name: "HomeLetter",
  components: {
    MainBarMenu,
    HeadingUser,
    TemplateLetter,    
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      header_img: "",
      footer_img: "",
      signature1: '',
      signature2: "",
      keyComponent: 0,
      templateLocal: [],
      legalContext: '',
      name1: '',
      name2: '',
      position1: '',
      position2: '',
      msjModal: '',
    };
  },
  beforeMount() {
    this.actGetTemplate().then(() =>{
      this.templateLocal = this.template.data;
      this.legalContext = this.template.data.legal_context;
      this.name1 = this.template.data.name1;
      this.name2 = this.template.data.name2;
      this.position1 = this.template.data.position1;
      this.position2 = this.template.data.position2;
    });
  }, 
  computed: {
    ...mapState("modCore", ["user"]),
    ...mapState("modEditLetter", ["template","loading"]),    
  },
  methods: {
    ...mapActions("modEditLetter", [
      "actChangeLetter",
      "actGetTemplate",
    ]),
    
    signature1Selected() {
      const dato = document.querySelector('#signature1');
      this.signature1 = dato.files[0].name;      
    },
    signature2Selected() {
      const dato = document.querySelector('#signature2');
      this.signature2 = dato.files[0].name;      
    },
    headerSelected() {
      const dato = document.querySelector('#header');
      this.header_img = dato.files[0].name;
      //alert(this.header_img)
    },
    footerSelected() {
      const dato = document.querySelector('#footer');
      this.footer_img = dato.files[0].name;      
    },

    async sendLetterChgs() {
      this.error.flag = false;
      this.error.class = "";
      let legal_context = (this.legalContext == '') ? '.' : this.legalContext;
      let name1L = (this.name1 == '') ? '.' : this.name1;
      let name2L = (this.name2 == '') ? '.' : this.name2;
      let position1L = (this.position1 == '') ? '.' : this.position1;
      let position2L = (this.position2 == '') ? '.' : this.position2;      

      var formData = new FormData();
      
      var header = document.querySelector('#header');
      formData.append("header_img", header.files[0]);
      
      var footer = document.querySelector('#footer');
      formData.append("footer_img", footer.files[0]);
      
      var signature1 = document.querySelector('#signature1');
      formData.append("signature1", signature1.files[0]);

      var signature2 = document.querySelector('#signature2');
      formData.append("signature2", signature2.files[0]);

      formData.append("legal_context", legal_context);
      formData.append("name1", name1L);
      formData.append("name2", name2L);
      formData.append("position1", position1L);
      formData.append("position2", position2L);

      await this.actChangeLetter(formData).then(() =>{
                  this.showModal("La plantilla se actualizó correctamente",0);
                  this.keyComponent += 1;

                }).catch((response) => {
                  this.error.flag = true;
                  this.error.class = "is-invalid";
                  this.error.message = "Ocurrio un error al actualizar los datos: "+response;
                });
    },

    showModal(msj,flag) {
      this.msjModal = msj;
      this.flagPath = flag;
      this.$refs['my-modal'].show()
    },
    hideModal() {
      this.$refs['my-modal'].hide()
      if(this.flagPath == 1){
        this.$router.push({ path: '/solicitudes' });
      }
    },
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
.page-letter {
  .title-3 {
        font-size: 24px;
        font-weight: bold;
        color: #1C3A4E;
      }
  .cont-letter-text {    
    .cont-title {
      color: #1C3A4E;
      .title-1 {
        font-family: "Open Sans";
        font-size: 40px;
        font-weight: bold;
        color: #1C3A4E;
      }
      .title-2 {
        font-weight: bold;
        font-size: 25px;
        line-height: 27px;
        color: #1C3A4E;

        @media (min-width: 768px) {
          font-size: 80px;
          line-height: 80px;
        }
      }
    }
    .form-letter {      
      .boton1 {
        background: #ffffff;
        color: #1C3A4E;
        border-color: #1C3A4E;
        font-family: "Poppins";
        border-radius: 100px;
        height: 32px;
        width: 200px;
        font-size: 14px;
        text-align: center !important;  
        padding-left: 15%;
        padding-right: 5%;
        &:hover {
          background: darken(#f6f8fa, 5);
        }
      }
      .boton2 {
        background: #8d9092;
        color: #ffffff;
        border-color: #8d9092;
        font-family: "Poppins";
        border-radius: 50px;
        height: 32px;
        width: 150px;
        font-size: 14px;
        text-align: center !important;  
        padding-left: 5%;
        padding-right: 5%;
        &:hover {
          background: darken(#7a7c7e, 5);
        }
      }
      .boton3 {
        background: none!important;
        border: none;
        padding: 0!important;
        /*optional*/
        font-family: "Poppins";
        /*input has OS specific font-family*/
        color: #069;
        text-decoration: underline;
        cursor: pointer;
      }
      .p1 {
        font-family: "Open Sans";
        font-style: normal;
        font-weight: 600;
        font-size: 15px;
        line-height: 22px;
        color: #1C3A4E;
      } 
    }
  }   
  .p2 {
          font-family: "Open Sans";
          font-style: normal;
          font-weight: bold;
          font-size: 10px;
          line-height: 16px;
          color: #303030;
          padding-left: 5%;
          text-align: right;
          vertical-align: bottom;
          text-decoration: underline;
  }
  .p3 {
          font-family: "Open Sans";
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 18px;
          color: #454545;
  }

  .centerImg {
    width: 19px;
    height: 19px;
    //position: absolute;
    //left: 50%;
    top: 100%; 
    //margin-left: -8px;
    //margin-top: 8px;
    float: left;
    fill: white;
    //clear: right;
  }  
  .custom-file-upload {
      border: 1px solid #ccc;
      display: inline-block;
      padding: 1px 12px;
      cursor: pointer;
  }
  input[type="file"] {
    display: none;
  }
}
</style>